// extracted by mini-css-extract-plugin
module.exports = {"sectionWrap":"_2XGEY","sectionTitle":"XsyCw","filterSection":"_3GCFC","chip":"_1fFG8","wrapper":"_1Pa_l","outerBtn":"_15w2t"};